import {PayloadAction} from '@reduxjs/toolkit';
//types
import {IOrganizationUserInfo} from '../../utils/types';
import {IUserReducer, IUserRegisterLoginResponse, IUserTable} from '@/utils/types/user.interface';

export const pendingOperation = (state: IUserReducer) => {
	state.isLoading = true;
};

export const rejectedOperation = (state: IUserReducer) => {
	state.isLoading = false;
};

export const userSignupOperation = (state: IUserReducer, {payload}: PayloadAction<IUserRegisterLoginResponse>) => {
	state.userInfo = payload.userInfo;
	state.isLoading = false;
};

export const userLoginOperation = (state: IUserReducer, {payload}: PayloadAction<IUserRegisterLoginResponse>) => {
	state.userInfo = payload.userInfo;
	state.isLoading = false;
};

export const userLogoutOperation = (state: IUserReducer) => {
	state.userInfo = null;
	state.isLoading = false;
};

export const getUserInfoOperation = (state: IUserReducer, {payload}: PayloadAction<IOrganizationUserInfo>) => {
	state.userInfo = payload;
	state.isLoading = false;
};

export const changePasswordOperation = (state: IUserReducer) => {
	state.isLoading = false;
};

export const getUserTablesOperation = (state: IUserReducer, {payload}: PayloadAction<IUserTable[] | []>) => {
	state.userTables = payload;
	state.isLoading = false;
};
